import { Box, HStack, Button, Image, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { convertToHashAnswers, getQuestionID } from "../../../utils/Helper";
import { learningModes, questionTypes } from "../../../utils/LearningPathUtils";
import { AnswersLayout } from "./AnswerLayouts";
import "../../molecules/questionLayouts/QuestionLayout.css?__remix_sideEffect__";
import Assistant from "../ai-tutor/Assistant/Assistant";
import { handleRemoveExtraSpaceInBubbles } from "../../../utils/common-utils";
import { isNotEmptyOrNull } from "../../../utils/common-utils";
import { handleCopyClick } from "../../../utils/TutorConstants";
import { useCustomToast } from "../../../components/molecules/ai-tutor/useCustomToast";
import { useTutor } from "../../../context/AiTutorContext";
import { questionLayoutStyles } from "./QuestionsLayoutStyles";
import {
  MdOutlineKeyboardArrowUp,
  MdOutlineKeyboardArrowDown } from
"react-icons/md";
import pkg from "@inrscr/coschool-ui-components";
import styles from "../comprehensionLayout/SubQuestionLayout.module.css";
import { usePractice } from "../../../context/PracticeContext";
import ChatView from "../ai-tutor/ChatView/ChatView";

export const QuestionsLayout = (props) => {
  const { GlobalButton } = pkg;
  const showToast = useCustomToast();
  const {
    learningStepData,
    isFactual,
    userQuery,
    setTriggerHandleSend,
    isComprehensionDescChat
  } = useTutor();
  const { chatHistory, currentQuesIndex } = usePractice();
  const [currentQuestion, setCurrentQuestion] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [layoutType, setLayoutType] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const descQuestionTypes = [
  questionTypes.short_answer,
  questionTypes.long_answer,
  questionTypes.very_short_answer];


  const isDescQues = descQuestionTypes.includes(currentQuestion?.question_type);

  useEffect(() => {
    let quesObj = props?.questionObject;
    const questionObjCopy = { ...quesObj };
    let optionLayouts = questionObjCopy?.options_layout?.map((item) => {
      return handleRemoveExtraSpaceInBubbles(item);
    });
    quesObj.modified_options_layout = optionLayouts;

    setCurrentQuestion(quesObj);
  }, []);

  useEffect(() => {
    // Reset selected answer when question is closed
    if (!props.isOpen && props?.isComprehension) {
      setSelectedAnswer(null);
    }
  }, [props.isOpen]);

  const onSend = (item) => {
    setSelectedAnswer(item.answer);
    if (!props.isComprehension) {
      props.onAnswerChanged(
        item?.answer,
        currentQuestion,
        item?.hashedIndexAnswer,
        item?.selectedIndex,
        props?.isComprehension,
        ""
      );
    }
  };

  const handleNextClick = () => {
    if (isDescQues) {
      // For descriptive questions, trigger handleSend with the current userQuery
      if (userQuery?.trim() && !isSubmitted) {
        setIsSubmitted(true);
        props.onAnswerSubmit(userQuery);
        setTriggerHandleSend(true);
        // Close current question and open next one
        if (props?.isComprehension) {
          props.toggleOpen();
          // If not the last question, open the next one
          if (!props.isLastQuestion) {
            props.onNextQuestion();
          }
        }
      }
    } else if (selectedAnswer && !isSubmitted) {
      // For non-descriptive questions, use the selected answer
      setIsSubmitted(true);
      props.onAnswerSubmit(selectedAnswer);
      // Close current question and open next one
      if (props?.isComprehension) {
        props.toggleOpen();
        // If not the last question, open the next one
        if (!props.isLastQuestion) {
          props.onNextQuestion();
        }
      }
    }
  };

  const hasNoOptions = currentQuestion?.options_layout?.length == 0;

  return (
    <Box id="question-factual-component">
      <Box id="question-content-container">
        {!isFactual &&
        learningStepData &&
        learningStepData.dialog_entry_script &&
        learningStepData.dialog_entry_script.content &&
        <Assistant
          data-testid="dialog-entry-assistant"
          text={""}
          isCopy={false}
          isDialogScript={true}
          scriptData={learningStepData.dialog_entry_script.content} />

        }

        <Box
          className={`${props?.isComprehension && styles?.mainContainer} ${
          props?.isComprehension && (
          layoutType !== "row" ? styles?.twoRows : "")}`
          }>

          <Box className={props?.isComprehension && styles?.container}>
            {/* Index - only show for comprehension */}
            {props?.isComprehension &&
            <Box className={styles?.indexColumn}>
                <Box className={styles?.index}>{props?.questionIndex + 1}</Box>
              </Box>
            }

            {/* Content Column */}
            <Box className={props?.isComprehension && styles?.contentColumn}>
              {isNotEmptyOrNull(currentQuestion?.question_type) &&
              currentQuestion?.question_type !== questionTypes.fib &&
              <Box
                marginBottom={hasNoOptions ? "0px" : "20px"}
                id="question-display-container">

                    <Assistant
                  data-testid="question-assistant"
                  text={
                  currentQuestion?.question_layout ?
                  currentQuestion?.question_layout :
                  ""
                  }
                  isUser={props?.isUser || false}
                  isCopy={props?.allowToCopy || false}
                  handleCopyClick={() => {
                    handleCopyClick(props?.questionObject?.uuid);
                    showToast({
                      description: "Question ID copied to clipboard",
                      duration: 1000
                    });
                  }}
                  questionType={currentQuestion?.question_type}
                  isQuestion={true}
                  imagesList={currentQuestion?.images_details}
                  hideVin={props?.isComprehension ? true : false}
                  isComprehension={props?.isComprehension} />

                  </Box>
              }

              <Box
                id="options-container"
                className={`${
                currentQuestion?.question_type !== questionTypes.fib ?
                "optionsContainer" :
                "optionsContainerForFIB"}
                    ${
                props?.isComprehension && "comprehensionOptionContainer"}
                    `}
                marginBottom={hasNoOptions ? "0px" : "0px"}>

                <Box
                  sx={
                  !props?.isComprehension &&
                  questionLayoutStyles()?.answerLayoutContainer
                  }>

                  {(!props?.isComprehension || props?.isOpen) &&
                  <AnswersLayout
                    data-testid="answers-layout"
                    displayedQues={props?.displayedQues}
                    userAnswer={props?.userAnswer}
                    question_type={currentQuestion?.question_type}
                    question_id={getQuestionID(currentQuestion)}
                    options={currentQuestion?.options_layout}
                    modifiedOptions={currentQuestion?.modified_options_layout}
                    answers={
                    isNotEmptyOrNull(currentQuestion?.answers_index_hashed_keys) ?
                    currentQuestion?.answers_index_hashed_keys :
                    isNotEmptyOrNull(currentQuestion?.answers_key) ?
                    currentQuestion?.answers_key :
                    currentQuestion?.answers_layout
                    }
                    question={currentQuestion?.question}
                    option_image_details={
                    currentQuestion?.option_image_details
                    }
                    isDisabled={props?.isComprehension ? isSubmitted : false}
                    images_details={currentQuestion?.images_details}
                    onSend={onSend}
                    onAnswerSubmitted={
                    props?.isComprehension ?
                    isSubmitted :
                    props?.isAnswerSubmitted
                    }
                    isDontAllow={props?.isDontAllow || false}
                    allowToCopy={props?.allowToCopy || false}
                    currentQuestion={currentQuestion}
                    taskType={props.taskType}
                    isComprehension={props?.isComprehension}
                    setLayoutType={setLayoutType} />

                  }
                </Box>
              </Box>

              {props?.isComprehension &&
              props?.isOpen &&
              isDescQues &&
              chatHistory?.[`${currentQuesIndex}_${props?.questionIndex}`]?.
              length > 0 &&
              <Box>
                    <ChatView
                  history={
                  chatHistory?.[
                  `${currentQuesIndex}_${props?.questionIndex}`]

                  }
                  isDisplayUserQuery={true}
                  isDescAnsQues={true}
                  isComprehension={true} />

                  </Box>
              }
            </Box>

            {/* Actions Column - Chevron Icon */}
            {props?.isComprehension &&
            <Box className={styles?.actionsColumn}>
                <HStack spacing={2}>
                  {props?.isAnswerSubmitted &&
                <Text color="#419544" fontSize="16px" fontWeight="600">
                      Attempted
                    </Text>
                }
                  <Box onClick={props?.toggleOpen} cursor="pointer">
                    {props?.isOpen ?
                  <MdOutlineKeyboardArrowUp
                    className={styles?.icon}
                    color="#A19BC0" /> :


                  <MdOutlineKeyboardArrowDown
                    className={styles?.icon}
                    color="#A19BC0" />

                  }
                  </Box>
                </HStack>

                {props?.isOpen &&
              layoutType === "row" &&
              !isSubmitted &&
              !props?.isAnswerSubmitted &&
              <Box className={styles?.button}>
                      <GlobalButton
                  buttonText="Next"
                  buttonType="Primary"
                  size="medium"
                  state={
                  isDescQues ?
                  userQuery?.trim() &&
                  !isSubmitted &&
                  !props?.isAnswerSubmitted ?
                  "Enabled" :
                  "Disabled" :
                  selectedAnswer &&
                  !isSubmitted &&
                  !props?.isAnswerSubmitted ?
                  "Enabled" :
                  "Disabled"
                  }
                  onClick={handleNextClick} />

                    </Box>
              }
              </Box>
            }
          </Box>

          {/* Bottom Button for non-row layout */}
          {props?.isOpen &&
          props?.isComprehension &&
          layoutType !== "row" &&
          !isSubmitted &&
          !props?.isAnswerSubmitted &&
          <Box>
                <GlobalButton
              buttonText="Next"
              buttonType="Primary"
              size="medium"
              state={
              isDescQues ?
              userQuery?.trim() &&
              !isSubmitted &&
              !props?.isAnswerSubmitted ?
              "Enabled" :
              "Disabled" :
              selectedAnswer &&
              !isSubmitted &&
              !props?.isAnswerSubmitted ?
              "Enabled" :
              "Disabled"
              }
              onClick={handleNextClick} />

              </Box>
          }
        </Box>
      </Box>
    </Box>);

};